import {
  derogationActionEnum,
  derogationStatusEnum,
  type DerogationActionEnumKey,
  type DerogationDto,
} from 'korint-sdk';

// Pricing requires an approved QUOTE derogation, so the CONFIRM request can only follow it
export const isWaitingForQuoteDerogation = ({
  action,
  needsQuoteDerogation,
  derogations,
}: {
  action: DerogationActionEnumKey;
  needsQuoteDerogation: boolean | undefined;
  derogations: Pick<DerogationDto, 'action' | 'status'>[];
}) =>
  action === derogationActionEnum.CONFIRM &&
  needsQuoteDerogation !== false &&
  !derogations.some(
    ({ action: derogationAction, status }) =>
      derogationAction === derogationActionEnum.QUOTE && status === derogationStatusEnum.APPROVED,
  );
